import React from "react";
import CloseButton from "../../shared/icon-cross";
import InputOTPSingular from "../../shared/input-otp-singular/component";
import styles from "./styles.css";
import CallIcon from "./images/callIcon.svg";
import PropTypes from "prop-types";
import CountdownTimer from "../../shared/countdown-timer";

const BookingOtpRevamp = ({
    errorMessage,
    mobile,
    close,
    onChangeComplete = () => { },
    showSpinner,
    isMissCallEnabled = true,
    mobileNumber = "",
    showLoader = false,
    resendOtpHandler,
    onCompleteTimer,
    otpInput,
    otp,
    onSingularOtpChange,
    customHeading = "OTP Verification",
    isEditable = false,
    showClose = true
}) => {

    return (
        <div styleName={"styles.bookingotpWrapper"}>
            <div styleName={"styles.bookingotp"}>
                {showClose && <div styleName={"styles.close"}>
                    <CloseButton type="grey" onClick={close} />
                </div>}
                <h3>{customHeading}</h3>
                <div styleName={"styles.editPhone"}>Code sent to
                    <p>{mobileNumber || mobile}</p>
                    {isEditable && <span onClick={close}>EDIT</span>}
                </div>
                <div styleName={"styles.otpWrapper"}>
                    <InputOTPSingular
                        inputRef={otpInput}
                        prefilledOtp={otp}
                        onOtpChange={onSingularOtpChange}
                        errorMessage={errorMessage}
                        isOTPInvalid={!!errorMessage}
                        onOTPVerifyCallback={onChangeComplete}
                        isLoading={showSpinner}
                        isAutoFocus={true}
                    />
                </div>

                {
                    !showLoader && <p onClick={resendOtpHandler} styleName={"styles.resendOtp"}>Resend OTP</p>
                }

                {
                    showLoader && <p styleName={"styles.resendText"}>
                    Resend OTP in <CountdownTimer interval={30} onComplete={onCompleteTimer} onlyText={true} /> seconds
                    </p>
                }

                {
                    isMissCallEnabled && <React.Fragment>
                        <p styleName={"styles.orVerify"}>
                            <span>Or to Verify Instantly</span>
                        </p>
                        <div styleName={"styles.missedCallWrapper"}>
                            <div styleName={"styles.missedCall"}>
                                <img src={CallIcon} alt="call" />
                    Give us a missed call on <span>+91 9015977711</span>
                            </div>
                        </div>
                    </React.Fragment>
                }

            </div>
        </div>
    );
};

BookingOtpRevamp.propTypes = {
    errorMessage: PropTypes.string,
    onChangeComplete: PropTypes.func,
    mobile: PropTypes.string,
    close: PropTypes.func,
    showSpinner: PropTypes.bool,
    isMissCallEnabled: PropTypes.bool,
    mobileNumber: PropTypes.string,
    showLoader: PropTypes.bool,
    resendOtpHandler: PropTypes.func,
    onCompleteTimer: PropTypes.func,
    onSingularOtpChange: PropTypes.func,
    otpInput: PropTypes.object,
    otp: PropTypes.string,
    customHeading: PropTypes.string,
    isEditable: PropTypes.bool,
    showClose: PropTypes.bool
};

export default BookingOtpRevamp;
